<template>
  <div id="date-picker" v-click-outside="close" :style="style">
    <Calendar
      ref="datePicker"
      v-if="show"
      :locale="locale"
      @dayclick="selectDay"
    ></Calendar>
  </div>
</template>

<script>
import Calendar from "v-calendar/lib/components/calendar.umd";
import ClickOutside from "vue-click-outside";
import Helper from "@/models/Helper.js";
export default {
  name: "date-picker",
  components: {
    Calendar,
  },
  data() {
    return {
      show: false,
      locale: Helper.getLocale(this),
      style: {},
      passingData: [],
      onKeyUp: (e) => {
        if (e.key === "Escape") {
          this.show = false;
        }
      },
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    },
  },
  destroyed() {
    document.removeEventListener("keyup", this.keyUpHandler);
  },
  methods: {
    open(event, passingData) {
      this.show = true;
      this.passingData = passingData;
      this.style = {
        left: event.clientX + "px",
        top: event.clientY + "px",
      };
    },
    close(event) {
      if (event.target.type == "text" && !event.target.autofocus) return;
      const cellParts = event.target.className.split(" ");
      if(cellParts.includes("supplier-cell")) return;
      if (event.target.className != "date-change") {
        this.show = false;
      }
    },
    manualClose() {
      this.show = false;
    },
    selectDay(event) {
      console.log(event);
      this.$emit("dateSelected", event.id, this.passingData);
      this.show = false;
    },
  },
  mounted() {
    // prevent click outside event with popupItem.
    this.popupItem = this.$el;
  },

  // do not forget this section
  directives: {
    ClickOutside,
  },
};
</script>

<style scoped>
#date-picker {
  position: fixed;
  z-index: 1000;
}
</style>